import { defineMessage } from 'services/localization';

export const messages = {
    statusEnabled: defineMessage('enabled_1'),
    statusDisabled: defineMessage('disabled_1'),
    buttonEnable: defineMessage('enable'),
    buttonDisable: defineMessage('disable'),
};
